import * as React from "react";
import { observer } from "mobx-react";
import { InputText } from "../Shared";

export interface IInputTextComponentProps {
	model: InputText;
	required?: boolean;
	onChange?: () => void;
	testId?: string;
	testName?: string;
	focus?: boolean;
	languageDependent?: boolean;
	languageCaption?: string;
	region?: string;
	tabIndex?: number;
	onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
}

@observer
export class InputTextComponent extends React.Component<
	IInputTextComponentProps,
	{}
> {
	componentDidMount() {
		if (this.props.focus) {
			this.refs.input.focus();
		}
	}

	handleChange = (event: React.FormEvent<any>) => {
		this.props.model.value = (event.target as any).value as string;
		if (
			this.props.model.regex &&
			(!this.props.model.valueNeedsTranslation || this.props.model.value)
		) {
			let regex: RegExp;
			try {
				regex = new RegExp("^" + this.props.model.regex + "$");
			} catch (e) {
				regex = null;
			}
			this.props.model.isValid = regex
				? regex.test(this.props.model.value)
				: false;
		} else {
			this.props.model.isValid = true;
			this.props.model.validationMessage = null;
		}
		if (this.props.onChange) {
			this.props.onChange();
		}
		this.forceUpdate();
	};

	refs: {
		[key: string]: HTMLElement;
		input: HTMLElement;
	};

	render() {
		let label = this.props.model.label ? (
			<span>
				{this.props.model.label}
				{this.props.languageDependent ? (
					this.props.region.toLowerCase() == "001" ? (
						<img
							className="lang-dependent"
							title={this.props.languageCaption}
							src={
								"../../images/flags/" +
								this.props.region +
								".png"
							}
						/>
					) : (
						<div
							title={this.props.languageCaption}
							className={
								"flag flag-" + this.props.region.toLowerCase()
							}
						/>
					)
				) : null}
			</span>
		) : null;

		let input = this.props.model.isMultiLine ? (
			<textarea
				ref="input"
				defaultValue={
					this.props.model.value ? this.props.model.value : ""
				}
				onChange={this.handleChange}
				placeholder={this.props.model.placeHolder}
				disabled={this.props.model.isReadOnly}
				className={
					!this.props.model.isValid ? "is--input-invalid" : null
				}
				tabIndex={this.props.tabIndex}
				data-test-id={this.props.testId}
				data-test-name={this.props.testName}
				onKeyDown={this.props.onKeyDown}
			></textarea>
		) : (
			<input
				type="text"
				ref="input"
				value={this.props.model.value ? this.props.model.value : ""}
				onChange={this.handleChange}
				placeholder={this.props.model.placeHolder}
				disabled={this.props.model.isReadOnly}
				className={
					!this.props.model.isValid ? "is--input-invalid" : null
				}
				tabIndex={this.props.tabIndex}
				data-test-id={this.props.testId}
				data-test-name={this.props.testName}
				onKeyDown={this.props.onKeyDown}
			/>
		);

		let message = this.props.model.validationMessage ? (
			<span className="is--validation-note">
				{this.props.model.validationMessage}
			</span>
		) : null;

		return (
			<label className={this.props.required ? "required" : null}>
				{label}
				{input}
				{message}
			</label>
		);
	}
}
